import { render, staticRenderFns } from "./DocumentsShowTableItem.vue?vue&type=template&id=aff43b08&scoped=true&"
import script from "./DocumentsShowTableItem.vue?vue&type=script&lang=js&"
export * from "./DocumentsShowTableItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsShowTableItem.vue?vue&type=style&index=0&id=aff43b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff43b08",
  null
  
)

export default component.exports